"use client";

import type { ReactNode } from "react";
import { ThemeProvider } from "@/lib/useTheme";
import { LanguageProvider } from "@/lib/useLanguage";
import type { Language } from "@/lib/translations";
import { FeedbackProvider } from "@/components/feedback";
import { HtmlLangSync } from "@/components/HtmlLangSync";
import { ServiceWorkerLifecycle } from "@/components/ServiceWorkerLifecycle";
import { PreferredLanguageSync } from "@/components/LanguageProviderWrapper";

type AppProvidersProps = {
  children: ReactNode;
  initialLanguage?: Language;
};

export default function AppProviders({
  children,
  initialLanguage = "es",
}: AppProvidersProps) {
  return (
    <ThemeProvider>
      <LanguageProvider initialLanguage={initialLanguage}>
        <ServiceWorkerLifecycle />
        <HtmlLangSync />
        <PreferredLanguageSync />
        <FeedbackProvider>{children}</FeedbackProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}
